import API from '../api';

/**
 * Verify access to the signature section
 */
export const verifySignatureAccess = (accessCode: string) => async (
  dispatch,
) => {
  const response = await API.request('/signatures/access', 'POST', {
    accessCode,
  });
  return await response.json();
};

/**
 * Store a new signature to a booking & customer
 */
export const storeSignature = (payload: {
  booking_id: number;
  company_id?: number;
  driver_id?: number;
  image: any;
}) => async (dispatch) => {
  const response = await API.request('/signatures', 'POST', payload);
  return response.json();
};

/**
 * Get the customer signature for a booking
 */
export const getSignature = (bookingID: number, driverID: number) => async (
  dispatch,
) => {
  const response = await API.request(
    `/signatures?booking_id=${bookingID}&driver_id=${driverID}`,
    'GET',
  );
  return response.json();
};

/**
 * Remove the customer signature for a booking
 */
export const removeSignature = (bookingID: number, driverID: number) => async (
  dispatch,
) => {
  await API.request(
    `/signatures?booking_id=${bookingID}&driver_id=${driverID}`,
    'DELETE',
  );
};
